<template>
  <GmapMap
      ref="map"
      class="base-map-polygons"
      :center="{lat: 0, lng: 0}"
      :zoom="10"
      :options="$options.MAP_OPTIONS"
      map-type-id="terrain"
  >
  <GmapPolygon
    v-for="(polygon, index) in polygons"
    v-bind:key="index"
    ref="mapPlygon"
    :path="polygon"
    :options="$options.MAP_POLYGON_OPTIONS"
    />
  </GmapMap>
</template>

<script>
import styles from '@utils/mapStylesDark'
import { gmapApi } from 'vue2-google-maps'

const MAP_OPTIONS = {
  mapTypeControl: false,
  streetViewControl: false,
  styles,
  zoomControl: false,
  fullscreenControl: true,
  gestureHandling: 'cooperative'
}

const MAP_POLYGON_OPTIONS = {
  strokeColor: '#102130',
  strokeWeight: 2,
  fillColor: '#dff2ff',
  fillOpacity: 0.5
}

export default {
  name: 'BaseMapPolygons',
  MAP_OPTIONS,
  MAP_POLYGON_OPTIONS,
  props: {
    polygons: { type: Array, default: () => [] }
  },
  computed: {
    google: gmapApi
  },
  mounted() {
    this.$gmapApiPromiseLazy().then(() => {
      this.fitBounds()
    })
  },

  methods: {
    fitBounds() {
      let bounds = new this.google.maps.LatLngBounds()

      this.polygons.forEach(points => {
        points.forEach(point => bounds.extend(point))
      })
      this.$refs.map.fitBounds(bounds)
    }
  }
}
</script>

<style>
.base-map-polygons {
  width: 100%;
  height: 300px;
}
</style>
